const APIS = {
  STAFF: "usermanagementservice/api/staff/",
  USER: "usermanagementservice/api/user/",
  USER_PROFILE: "logisticservice/api/user-profile/",
  MERCHANT: "logisticservice/api/merchant/",
  CUSTOMER: "logisticservice/api/customer/",
  CONTACT_GROUP: "/contactservice/api/contact-groups/",
  CLIENT: "/projectsettingsservice/api/configuration/",
  BRANCH: "/logisticservice/api/branch/",
  CARGO_DELIVERY_CHARGE: "/logisticservice/api/delivery-charge/cargo/",
  SERVICE_TYPE: "logisticservice/api/service-type/",
  LOCATION: "logisticservice/api/location/",
  PAYMENT_METHOD_TYPE: "logisticservice/api/payment-method/",
  PRODUCT_TYPE: "logisticservice/api/product-type/",
  DELIVERY_CHARGE: "logisticservice/api/delivery-charge/",
  SYNC_CONTACT: "/contactservice/api/contact-groups/sync/",
  DELIVERY_CHARGE_TEMPLATE: "logisticservice/api/delivery-charge-template/",
  API_KEY: "apiservice/api/v1/api-key/",
  CREATE_ACCOUNT_PARTY: "/accountingservice/api/party/",
  CODE: "logisticservice/api/merchant/next-series",
};

export default APIS;
